"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
var React = require("react");
var styled_1 = require("../../styled");
var EnvirioBadge = function (_a) {
    var children = _a.children, className = _a.className, onClick = _a.onClick, style = _a.style;
    return (React.createElement("span", { className: className, onClick: onClick, style: style || {} }, children));
};
var BaseBadge = styled_1.default(EnvirioBadge)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  height: min-content;\n  font-size: 1rem;\n  font-weight: bold;\n  padding: 2px 0.667rem;\n  text-align: center;\n  border-radius: 0.33rem;\n  color: ", ";\n"], ["\n  display: inline-block;\n  height: min-content;\n  font-size: 1rem;\n  font-weight: bold;\n  padding: 2px 0.667rem;\n  text-align: center;\n  border-radius: 0.33rem;\n  color: ", ";\n"])), function (props) { return props.theme.colors.white; });
exports.Badge = styled_1.default(BaseBadge)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: ", ";\n  font-weight: ", ";\n"], ["\n  background: ",
    ";\n  font-weight: ",
    ";\n"])), function (props) {
    return props.variant
        ? props.theme.badges[props.variant].bg
        : props.backgroundColor ? props.backgroundColor : props.theme.badges.default.bg;
}, function (props) {
    return props.textWeight === 'light' ? '300' : 'bold';
});
exports.default = exports.Badge;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map